import { defineMessages } from 'react-intl'

export default defineMessages({
  iosDownloadAltText: {
    id: 'appsinfo.iosdownloadalttext',
    defaultMessage: 'Download on the App Store (opens in a new browser tab)',
  },
  playStoreAltText: {
    id: 'appsinfo.androiddownloadalttext',
    defaultMessage: 'Get it on Google Play (opens in a new browser tab)',
  },
})
